export default {
    yes: "Tak",
    no: "NIE"
}